'use strict';

function LoginDialog() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.loggedInMsg = 'Dashboard';
  this._session = new Session();
  this.analytics = new Analytics();
  this.extends = [_AnalyticsData];
  this.notification = $('#Notification');

  this.init = function () {
    if (location.pathname == '/login') {
      return $(this.node).remove();
    }

    this.analytics.update(this.analyticsData, this);
  };

  this.initAllReady = function () {
    var dialog = $('#login__dialog');
    $(this.node).show();
    $(this.node).on('click', $.proxy(this._requestLoginDialog, this));
    if (dialog.length) {
      dialog.mogo().onClickClose = $.proxy(this._onClickCloseDialog, this);
    }
  };

  this._requestLoginDialog = function (event) {
    var _this = this;

    event.preventDefault();
    if (!$('#login__dialog').length) {
      var dialog = $("<div id='login__dialog' class='mogo-ui-dialog--dark mogo-ui-dialog--transparent darkLayout small-12'></div>").mogo().create('Dialog', {
        url: '/login-dialog',
        disableBackgroundScroll: true,
        fixFormsOnTouchDevices: true
      });
      this._checkForDialogContent(dialog);
    } else {
      $('#login__dialog').mogo().show();
    }
    this._hideNavigation();

    // HACK: setTimout is used to send this event after the google tag manager link click event.
    setTimeout(function () {
      _this.analytics.forcePushEvent('login-dialog');
    }, 50);
  };

  this._checkForDialogContent = function (dialog) {
    var dialogContent = $('[data-mogo-page="LogIn"]', dialog.node);
    if (dialogContent.length) {
      this.setupNewDialog(dialogContent, dialog);
    } else {
      var target = this;
      setTimeout(function () {
        target._checkForDialogContent(dialog);
      }, 500);
    }
  };

  this.setupNewDialog = function (dialogContent, dialog) {
    dialogContent.mogo().parse();
    $(dialog.node).mogo().show();
    this._setNotificationPosition();
    $('.icon--close', dialog.node).on('click', $.proxy(this._onClickClose, this));
  };

  this._onClickClose = function () {
    this.notification.mogo().hideNotification();
    this.notification.mogo().positioning();
    this.analytics.forcePushEvent('virtual-page-view');
  };

  this._hideNavigation = function () {
    if ($('.marketing-nav').length > 0) {
      $('.marketing-nav').mogo().toggleHamburger();
    }
  };

  this._setNotificationPosition = function () {
    this.notification.css('top', '0px');
  };

  this._analyticsDialogClose = function () {
    var _pageUrl = window.location.pathname;

    dataLayer.push({
      event: 'DLevent.Pageview',
      Page: _pageUrl
    });
  };

  this._onClickCloseDialog = function () {
    this._analyticsDialogClose();
  };
}